import { render, staticRenderFns } from "./SaleDocPaymentPref.vue?vue&type=template&id=8c778b46&"
import script from "./SaleDocPaymentPref.vue?vue&type=script&lang=js&"
export * from "./SaleDocPaymentPref.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports